module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-3_BW2-p-500-b6f1f5f07f1604bf81eabe1ec7c72e23.jpg";